import {
  HaLicenseDetail,
  IsFullAccess,
  useAppSelector,
  useGetEntitlementsQuery
} from '@monorepo/shared';
import {
  selectCurrentAccount,
  selectEntitlements
} from '@monorepo/shared/store/accountSlice';
import { useNavigate, useParams } from 'react-router-dom';
import { HomeElms, server } from '../../config/const';
import { Button, IconButton, List, Loader, Modal, Stack } from 'rsuite';
import { useEffect, useState } from 'react';
import CheckOutlineIcon from '@rsuite/icons/CheckOutline';
import { IoCloudUploadOutline } from 'react-icons/io5';
import { ProvisionStatusButton } from './ProvisionStatus';

export const AssetList = () => {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const [items, setItems] = useState<Record<string, any>[]>([]);
  const currentAccount = useAppSelector(selectCurrentAccount);
  const { data, isError, isSuccess, isLoading, isFetching } =
    useGetEntitlementsQuery(
      {
        server: server,
        account_id: currentAccount.account_id
      },
      { skip: !currentAccount.account_id }
    );
  useEffect(() => {
    if (data) {
      const used_list = data?.used_sn_list || [];
      const arr = data?.entitlements
        .map((e: Record<string, any>) => {
          const obj =
            used_list.find(
              (o: Record<string, any>) => o.sn === e.serialNumber
            ) || {};
          return {
            isExpired: new Date() > new Date(e.end_date),
            value: e.serialNumber,
            isProvisioned: !!obj.instance_id,
            isProvisioning: obj?.sn && !obj.instance_id,
            ...obj
          };
        })
        .sort(
          (a: Record<string, any>, b: Record<string, any>) =>
            Number(a.isProvisioned) - Number(b.isProvisioned)
        );
      setItems(arr);
    }
  }, [data]);
  const goToProvision = (sn: string) => {
    navigate(`provision/${sn}`);
  };
  return (
    <>
      <div className="grid-item asset">
        <div className="grid-header">
          <div className="title">
            <i className="icon-fortinetone-knowledgeBase"></i>
            Assets
          </div>
        </div>
        <div className="grid-content">
          {isLoading || isFetching ? (
            <div style={{ height: '100%', position: 'relative' }}>
              <Loader size="xs" content="Loading..." center />
            </div>
          ) : (
            <List size="sm" className="custom-overflow">
              {items.map((item: Record<string, any>, index: number) => (
                <List.Item key={index} index={index}>
                  <Stack justifyContent="space-between">
                    {item.value}
                    <div
                      style={{
                        width: '110px',
                        display: 'grid',
                        placeItems: 'center'
                      }}
                    >
                      {item.isExpired ? (
                        <AssetIndicator
                          account_id={currentAccount.account_id}
                          sn={item?.value}
                          btn_text={'Expired'}
                          btn_color={'red'}
                        />
                      ) : item.isProvisioned ? (
                        <CheckOutlineIcon
                          color="green"
                        />
                      ) : item.isProvisioning &&
                        currentAccount?.user_type === 'Master' ? (
                        <ProvisionStatusButton
                          sn={item.value}
                          task_id={''}
                          account_id={currentAccount?.account_id}
                          region_alias={item.region_alias}
                        />
                      ) : (
                        <Button
                          startIcon={
                            <IoCloudUploadOutline color="var(--fc-blue)" />
                          }
                          style={{ width: '100px' }}
                          size="xs"
                          appearance="ghost"
                          title="Provision Instance"
                          disabled={
                            currentAccount?.user_type !== 'Master' ||
                            !IsFullAccess(currentAccount, HomeElms.fcName) ||
                            !!groupId
                          }
                          onClick={() => {
                            goToProvision(item.value);
                          }}
                        >
                          Provision
                        </Button>
                      )}
                    </div>
                  </Stack>
                </List.Item>
              ))}
            </List>
          )}
        </div>
      </div>
    </>
  );
};
interface IProps {
  account_id: string;
  sn: string;
  btn_text?: string;
  btn_color?: 'red' | 'green' | 'cyan';
  btn_appearance?: any;
}
export const AssetIndicator = ({
  account_id,
  sn,
  btn_text,
  btn_color,
  btn_appearance
}: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  return (
    <>
      <Button
        color={btn_color}
        onClick={() => setOpen(true)}
        className="icon-btn"
        appearance={btn_appearance || 'link'}
        style={{
          fontSize: '1em',
          padding: '0'
        }}
      >
        {btn_text}
      </Button>
      <Modal
        size={660}
        open={open}
        onClose={() => setOpen(false)}
        className="asset-detail-modal"
      >
        <Modal.Header>
          <Modal.Title>License Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AssetDetail account_id={account_id} sn={sn} />
        </Modal.Body>
      </Modal>
    </>
  );
};
interface IAssetDetailProps {
  account_id: string;
  sn: string;
}
export const AssetDetail = ({ account_id, sn }: IAssetDetailProps) => {
  const assets = useAppSelector(selectEntitlements);
  const [data, setData] = useState<Record<string, string>[]>([]);
  useEffect(() => {
    if (assets?.[account_id]) {
      const res = assets[account_id]?.entitlements?.find(
        (e: Record<string, string>) => e.serialNumber === sn
      );
      if (res?.entitlements) {
        setData(res.entitlements);
      }
    }
  }, [assets, account_id, sn]);
  return (
    <div style={{ height: '100%' }}>
      <HaLicenseDetail data={data} />
    </div>
  );
};
